import { ClubeLogo, SkeletonHeaderHome } from '@ferreri/prever-component-lib';
import dynamic from 'next/dynamic';
import React from 'react';

type HeaderProps = {
  image?: React.ReactNode;
};

const HeaderHomeNotificationDynamic = dynamic<Required<HeaderProps>>(
  () => import('notification/HeaderHomeNotification'),
  { loading: () => <SkeletonHeaderHome /> },
);

export const HeaderHomeNotification = (props: HeaderProps) => {
  const image = props.image || <ClubeLogo />;

  return <HeaderHomeNotificationDynamic image={image} />;
};
